import { Injectable } from '@angular/core';
import { Recebimento } from '../models/recebimento';
import { Result } from '../models/result';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../../environments/environment';
import { CreateRecebimentoDTO } from '../../features/recebimento/models/create-recebimento';
import { FilaSeguranca } from '../../features/fila/models/fila-seguranca';
import { FilaProdImprod } from '../../features/fila/models/fila-produtivo-improdutivo';
import { FilaFiscal } from '../../features/fila/models/fila-fiscal';
import { RecebimentoFilter } from '../../features/recebimento/models/recebimento-filter';
import { Fila } from '../models/fila';
import { LcbFilaSeguranca } from '../../features/fila/models/lcb-fila-seguranca';
import { LcbFilaProdEmb } from '../../features/fila/models/lcb-fila-produtivo-embalagem';
import { GerarSenhaDTO } from '../../features/control-pass/models/gerar-senha.dto';
import { RegisteredDriverDetailsDTO } from '../models/biometria';

@Injectable({ providedIn: 'root' })
export class RecebimentoService {
  apiUrl = environment.urlControlCenterApi + 'recebimento';

  constructor(private http: HttpClient) {}

  getById(id: number) {
    return this.http.get<Result<Recebimento>>(`${this.apiUrl}/${id}`);
  }

  getAll() {
    return this.http.get<Result<Recebimento[]>>(`${this.apiUrl}`);
  }

  getFiltered(filters: RecebimentoFilter) {
    const url = `${this.apiUrl}/filtered`;
    const queryParams = [];

    if (filters.dataEntrada) {
      queryParams.push(`entrada=${filters.dataEntrada}`);
    }

    if (filters.dataSaida) {
      queryParams.push(`saida=${filters.dataSaida}`);
    }

    if (filters.fornecedor) {
      queryParams.push(`fornecedor=${filters.fornecedor}`);
    }

    if (filters.notaFiscal) {
      queryParams.push(`nota-fiscal=${filters.notaFiscal}`);
    }

    if (filters.direcionamento) {
      queryParams.push(`direcionamento=${filters.direcionamento}`);
    }

    if (filters.registro) {
      queryParams.push(`registro=${filters.registro}`);
    }

    if (filters.senha) {
      queryParams.push(`senha=${filters.senha}`);
    }
    if (filters.local) {
      queryParams.push(`local=${filters.local}`);
    }

    const queryString = queryParams.length ? `?${queryParams.join('&')}` : '';
    const fullUrl = url + queryString;
    return this.http.get<Result<Recebimento[]>>(fullUrl);
  }

  insert(data: CreateRecebimentoDTO) {
    return this.http.post<Result<Recebimento>>(this.apiUrl, data);
  }

  generatePassAndReceiving(data: GerarSenhaDTO) {
    return this.http.post<Result<Recebimento>>(
      `${this.apiUrl}/generate-pass`,
      data,
    );
  }

  update(data: Recebimento) {
    return this.http.put<Result<Recebimento>>(`${this.apiUrl}`, data);
  }

  delete(id: number) {
    return this.http.delete<Result<boolean>>(`${this.apiUrl}/${id}`);
  }

  processamentoSeguranca(data: FilaSeguranca) {
    return this.http.put<Result<Fila>>(
      `${this.apiUrl}/processamento-seguranca`,
      data,
    );
  }

  processamentoFiscal(data: FilaFiscal) {
    return this.http.put<Result<Fila>>(
      `${this.apiUrl}/processamento-fiscal`,
      data,
    );
  }

  processamentoProdImprod(data: FilaProdImprod) {
    return this.http.put<Result<Fila>>(
      `${this.apiUrl}/processamento-produtivo-improdutivo`,
      data,
    );
  }

  processamentoLcbSeguranca(data: LcbFilaSeguranca) {
    return this.http.put<Result<Fila>>(
      `${this.apiUrl}/processamento-lcb-seguranca`,
      data,
    );
  }

  processamentoLcbProdEmb(data: LcbFilaProdEmb) {
    return this.http.put<Result<Fila>>(
      `${this.apiUrl}/processamento-lcb-produtivo-embalagem`,
      data,
    );
  }

  getSecurityDetails(recebimentoId: number) {
    return this.http.get<Result<RegisteredDriverDetailsDTO>>(
      `${this.apiUrl}/${recebimentoId}/security-details`,
    );
  }
}
